export default __webpack_public_path__ + "static/media/logo-program.091418d4.png";